import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export const useFormChangeWatcher = (onChange: () => void) => {
  const { watch } = useFormContext();

  useEffect(() => {
    const subscription = watch(() => {
      onChange();
    });
    return () => subscription.unsubscribe();
  }, [watch, onChange]);
};
